import { render, staticRenderFns } from "./previewImgFile.vue?vue&type=template&id=1e974567&scoped=true&"
import script from "./previewImgFile.vue?vue&type=script&lang=js&"
export * from "./previewImgFile.vue?vue&type=script&lang=js&"
import style0 from "./previewImgFile.vue?vue&type=style&index=0&id=1e974567&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e974567",
  null
  
)

export default component.exports